module.exports = __webpack_public_path__ + "img/cabinet_fault.2e5186b3.svg";